import { extractCenterId } from "./center";

export const isSupport = user => (
  user && user.groups && user.groups.is_support
);

export const isSuperAdmin = user => (
  user && user.groups && user.groups.is_super_admin
);

// Chef d'équipe : droit personnalisé « Chef d'équipe » (flag de `/admin-user/`)
export const isTeamLeader = user => (
  Boolean(user && user.groups && user.groups.is_team_leader)
);

// Ordre des manquants imposé sur le centre sélectionné dans le flow (Reuilly).
// Lu sur la liste des centres du chargement, le centre de staff_info peut différer.
export const isMissingQueueEnforced = (state) => {
  const user = state && state.user;
  const centerId = extractCenterId(user);
  const centers = (state && state.m && state.m.metas && state.m.metas.centers)
    || (state && state.dispatch && state.dispatch.metas && state.dispatch.metas.centers)
    || [];
  const center = centers.find(c => c.id === centerId);
  if (center) return Boolean(center.missing_products_queue_enforced);
  return Boolean(user && user.groups && user.groups.missing_products_queue_enforced);
};

export const isAdmin = user => (
  user && user.groups && user.groups.is_manager
);

export const isDockStaff = user => (
  user && user.groups && user.groups.is_dockstaff
);

export const isHubManager = user => (
  user && user.groups && user.groups.is_hub_manager
);

// Données personnelles clients (nom complet, téléphone, adresse).
//
// Remplace une liste d'ids en dur. Le drapeau vient de `/admin-user/`, qui le
// calcule à partir du droit Django `accounts.view_customer_pii` (super admins
// inclus). Il ne sert QU'À L'AFFICHAGE : l'api masque déjà les payloads, ce
// n'est pas ce booléen qui protège la donnée.
export const canViewCustomerPii = user => (
  Boolean(user && user.groups && user.groups.can_view_customer_pii)
);
